import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

const Breadcrumb = ({ items }) => {
  return (
    <nav aria-label="Breadcrumb" className="mb-8" data-testid="breadcrumb">
      <ol className="flex items-center gap-1.5 text-sm text-carbon/50">
        <li>
          <Link to="/" className="hover:text-carbon transition-colors">Home</Link>
        </li>
        {items.map((item, i) => (
          <li key={item.label} className="flex items-center gap-1.5">
            <ChevronRight className="w-3.5 h-3.5" />
            {item.href ? (
              <Link to={item.href} className="hover:text-carbon transition-colors">{item.label}</Link>
            ) : (
              <span className="text-carbon font-medium">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
